import React from 'react';
import './Layout.css'; // Optional: For additional layout styling

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <main>
        {children}
      </main>
      <footer className="feedback-footer">
        <a href="https://forms.gle/1bEcJF5e4U8ZGaCe6" target="_blank" rel="noopener noreferrer">
          Give Feedback
        </a>
      </footer>
    </div>
  );
};

export default Layout;